<template>
  <li
    class="header-item position-relative"
    :class="{active: active == board}"
    @click="$emit('click', $event)"
    @dblclick="$emit('dblclick', $event)"
  >
    <span class="text-nowrap">{{ title }}</span>

    <div class="board-header-title-index" v-if="alt && index < 10">{{index}}</div>
  </li>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: ["board", "active"],
  computed: {
    ...mapState("keyboard", { alt: "alt" }),
    ...mapState("boards", { all: "all" }),
    index() {
      if (!this.board) return 0;
      if (!this.all) return 0;

      return this.all.indexOf(this.board) + 1;
    },
    title() {
      return this.board ? this.board.title : "";
    }
  }
};
</script>
<style lang="postcss">
.board-header-title-index {
  position: absolute;
  font-size: 0.75em;
  right: 3px;
  top: 3px;
}
</style>


